import {
    GET_USERS_REQUEST, GET_USERS_SUCCESS, GET_USERS_FAILURE, SET_FILTER,
} from '../constants/users.constants';
import { CHANGE_USER_STATUS_FAILURE, CHANGE_USER_STATUS_REQUEST, CHANGE_USER_STATUS_SUCCESS } from '../constants/change_user_status.constants';
import { setVal } from '../../../../../shared/helpers';

const initialState = {
    init_loading: false,
    User_list_table: {
        loading: false,
        data: [],
        data_count: null,
        filters: {
            limit: 25,
            offset: 0,
            page: 0,
            searchText: '',
            showSuspendent: false,
        },
        error: null,
    },
};

export const User_list = (state = initialState, action) => {
    switch (action.type) {
    case GET_USERS_REQUEST:
        return {
            ...state,
            init_loading: typeof action.init === 'boolean' ? action.init : false,
            User_list_table: {
                ...state.User_list_table,
                filters: { ...state.User_list_table.filters, ...action.filters },
                loading: true,
            },
        };
    case GET_USERS_SUCCESS:
        return {
            ...state,
            init_loading: false,
            User_list_table: {
                ...state.User_list_table,
                data: action.payload.users,
                data_count: action.payload.allUsersCount,
                loading: false,
            },
        };
    case GET_USERS_FAILURE:
        return {
            ...state,
            init_loading: false,
            User_list_table: {
                ...state.User_list_table,
                error: action.error,
            },
        };
    case SET_FILTER:
        setVal(state, action.path, action.value);
        return { ...state };
    // {
        // ...state,
        // User_list: {
        //   ...state.User_list,
        //   User_list_table: {
        //     ...state.User_list.User_list_table,
        //     filters: {
        //       ...state.User_list.User_list_table.filters,
        //       [action.key]: action.value
        //     }
        //   }
        // }
        // };
    case CHANGE_USER_STATUS_REQUEST:
        return {
            ...state,
            User_list_table: {
                ...state.User_list_table,
                data: state.User_list_table.data.map(user => (user.ref_user_id === action.params._id
                    ? { ...user, ref_user_status: action.params.status } : user)),
            },
        };
    case CHANGE_USER_STATUS_SUCCESS:
        return setVal(state, 'User_list_table.data',
            state.User_list_table.data.map(user => (user.ref_user_id === action._id
                ? { ...user, ref_user_status: action.user.status } : user)));
    case CHANGE_USER_STATUS_FAILURE:
        return {
            ...state,
            User_list_table: {
                ...state.User_list_table,
                error: action.error,
            },
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_list/redux/reducers/users_list.reducers.js